import { writable } from 'svelte/store';
// Create a writable store for Clerk.
const clerk = writable(null);
export default clerk;
